import tree from '@/components/tree.vue'
import { dwgl } from '@/axios'
import Page from '@/components/page.vue'
import myTables from '@/components/tables/tables.vue'
import DelData from '@/components/delToast.vue'
import { Message } from 'element-ui'
import { zzsh } from '@/axios'
let that;
export default{
	data(){
		return{
			getdata:{
				id:this.$store.state.user.userinfo.id,
				flag:this.$store.state.user.userinfo.flag,
				year: "",
				month: "",
				type: "",
				page: 1,
				status:2,
				focus:"",
				dw:this.$store.state.user.userinfo.dw,
			},
			delList:[],
			delFlag:"",
			tableData:[],
			loading: false,
			isshow: true,
			tabheight: '100%',
			tableHeader: [     // 表头
				{prop: 'hy_title', label: '活动主题'},
				// 如果后端传过来的值不是我们所预期的，此处可以如下判断修改，isok是是否需要渲染为el-tag,效果为下图
				{prop: 'h_stime', label: '时间',width:"110",formatData: function (val) {
						return that.$changeTime(val)
					}
				},
				{prop: 'type', label: '活动类型',width:"160"},
				{prop: 'dw', label: '发布党组织',width:"160"},
				// 如果后端传过来的值不是我们所预期的，此处可以如下判断修改，isok是是否需要渲染为el-tag,效果为下图
				{
					prop: 'sync_label', label: '活动标签', formatData: function (val) {
						return val.toString()
					}
				},
				// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
				{
					prop: 'oper', label: '操作', fixed: 'right', width: '120',
					oper: [
						{name: '详情', style: {color:'#bb0000'}, clickFun: this.showDetail},
						{name: '编辑', style: {color:'#bb0000'}, clickFun: this.edit},
						{name: '删除', style: {color:'#bb0000'}, clickFun: this.del},
					]
				}
			],
			// 活动类型列表
			typeList:[],
			totalPage:0,
			all_count:0,
			focus_count:0,//集中学习次数
			hours_count:0//学习课时
		}
	},
	components:{tree,Page,DelData,myTables},
	created(){that = this},
	methods:{
		// 数据
		dataList(){
			that.tableData = [];
			dwgl.activity(that.getdata).then(res => {
				if(res.data.pagedata.length > 0){
					that.tableData = res.data.pagedata;
				}
				that.totalPage = res.data.count;
				that.focus_count = res.focus_count?res.focus_count:0;
				that.hours_count = res.hours_count?res.hours_count:0;
				that.all_count = res.all_count?res.all_count:0;
			})
		},
		onekey(){
			// 一键签到
			const hyid = [],hyflag = []
			if(that.delList.length !== 0){
				that.tableData.forEach(ele => {
					that.delList.forEach((item,key) => {
						if(ele.hyid == item){
							hyid.push(ele.hyid)
							hyflag.push(ele.hy_flag)
						}
					})
				})
				zzsh.allSign({
					hyid:hyid,
					hyflag:hyflag
				}).then(res => {
					Message.success('签到成功')
					that.delList = [];
					that.dataList()
				})
			}else{
				Message.warning('请选择要签到的活动')
			}
		},
		// 详情
		showDetail(data){
			that.$router.push({
				path:"/zzhd_detaill",
				query:{
					hy_flag:data.hy_flag,
					hyid:data.hyid,
					flag:that.getdata.flag,
					dw:that.getdata.dw,
					uid:that.getdata.id,
				}
			})
		},
		// 编辑
		edit(data){
			that.$router.push({
				path:"/zzhd_add",
				query:{
					hyid:data.hyid,
					hy_flag:data.hy_flag,
					flag:that.getdata.flag,
					type:'edit',
					dw:data.dw,
					uid:that.getdata.id,
					pub_id:data.pub_id,
					pub_flag:data.pub_flag
				}
			})
		},
		// 新增活动
		goAdd() {
			that.$router.push({
				path:"/zzhd_add",
				query:{
					type:'add',
				},
			})
		},
		// 一键删除
		selectList(value){
			if(!!!value.length) return
			that.delList = value;
		},
		delAll(){
			if(that.delList.length == 0){
				Message.warning('请先选择要删除得数据')
			}else{
				that.delData();
			}
		},
		// 部分禁用删除
		selectEnable(row, rowIndex) {
			if (row.pub_flag == that.$store.state.user.userinfo.flag&&row.pub_id == that.$store.state.user.userinfo.id) {
			  return true
			}
		 },
		//	删除操作
		delData(){
			if(that.delList.length !== 0){
				const ids = [], flags = [];
				that.delList.forEach((item,key) => {
					ids.push(item.hyid)
					flags.push(item.hy_flag)
				})
				that.$refs.delDatas.showToast(res => {
					if(res){
						dwgl.delActivity({
							id:ids,
							flag:flags
						}).then(res => {
							if(res.code == 200){
								Message({
									type: 'success',
									message: '删除成功!'
								})
							}else{
								Message({
									type: 'error',
									message: res.msg
								})
							}
							that.getdata.page = 1;
							that.dataList();
						})
					}
				})
			}else{
				Message.warning('请先选择要删除得数据')
			}
		},
		// 删除
		del(data){
			that.delList = [];
			that.delList = [{hyid: data.hyid, hy_flag: data.hy_flag}];
			that.delData();
		},
		// 树形结构筛选
		treeSelect(data){
			that.getdata.id = data.id;
			that.getdata.flag = data.flag;
			that.getdata.dw = data.dw;
			that.getdata.page = 1;
			that.dataList();
		},
		// 分页筛选
		changedata(curret){
			that.getdata.page = curret;
			that.dataList();
		},
	},
	mounted() {
		that.dataList();
		that.$emit('selectTop',3)
		// 活动类型分类筛选列表
		dwgl.hyClass().then(res => {
			that.typeList = res;
		})
	}
}